// extracted by mini-css-extract-plugin
var _1 = "absolute-k6qtQ";
var _2 = "add-cGLm7";
var _3 = "details-Hg7sp";
var _4 = "disabled-SDA5n";
var _5 = "discount-CL84o";
var _6 = "discounts-YNbb3";
var _7 = "from-QBDFJ";
var _8 = "lists-NWM4f";
var _9 = "name-_ywAO";
var _a = "price-kfD_d";
var _b = "prices-r75Rt";
var _c = "product-B9_qe";
var _d = "sale-lGqWx";
var _e = "save-XSA6H";
var _f = "throw-r4i3Z";
var _10 = "wrapper-PjlWA";
export { _1 as "absolute", _2 as "add", _3 as "details", _4 as "disabled", _5 as "discount", _6 as "discounts", _7 as "from", _8 as "lists", _9 as "name", _a as "price", _b as "prices", _c as "product", _d as "sale", _e as "save", _f as "throw", _10 as "wrapper" }
